import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { Rtable } from '../class/rtabledata';

@Component({
  selector: 'app-active',
  templateUrl: './active.component.html',
  styleUrls: ['./active.component.css']
})
export class ActiveComponent implements OnInit {

  constructor( public httpClient: HttpClient,) { }
  menu_list:menulist = [{id:'0',name:'活動列表'},{id:'1',name:'新增活動'},]
  race_obj:any = {rank:1,reward_type:1,rid:1,num:1,tmp:'1',name:'',lv:1,diamond:10};
  now:string = '0';
  subnow:string = '0';
  ranklv:string = '1';
  tmp_banner_img_b64:{};
  tmp_content_img_b64:{};
  pageobj:page = {page:0,count:12,total_count:0};
  pageobj2:page = {page:0,count:20,total_count:0};
  rank_list:menulist = [];
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
  edit_data:any=[];
  view_data:any=[];
  data:any=[];
  posts_attributes:any=[];
  show_data_arr:any=[];
  gift_list:any=[];
  item_list:any=[];
  c_r_obj:any=[];
  choose_obj:any={now_g_tab:-1,tmp_gift_list:[]}
  posts_input:any=[];
  search_model:string = '';
  sort_obj:any = {column:'now_round_diamond',sort:'0'}
  loading:boolean=true;
  link:string = environment.link;
  ngOnInit(): void {
    this.default_edit_data();
    this.init_list();
  }

  default_edit_data(){
    this.edit_data = {only_diamond:2,name:'',type:'1',identity_type:[1],count_type:'1',target_ids:[],start_dt:'',end_dt:'',race_reward:[],gift_config:[],item_config:[],status:0};
  }

  choose_detail_item(item,type){
    if(type==1){
      const index = this.edit_data.item_config.findIndex((v)=>{
        return item.id == v;
      })
      if(index==-1){
        this.edit_data.item_config.push(item.id);
      }else{
        this.edit_data.item_config.splice(index,1)
      }
    }
  }

  choose_detail_gift(item,type){
    if(type==0){
      this.choose_obj.now_g_tab = item.id;
      this.choose_obj.tmp_gift_list = item.data;
    }else if(type==1){
      const index = this.edit_data.gift_config.findIndex((v)=>{
        return item.id == v;
      })
      if(index==-1){
        this.edit_data.gift_config.push(item.id);
      }else{
        this.edit_data.gift_config.splice(index,1)
      }
    }else if(type==2){
      const a = this.choose_obj.tmp_gift_list.map(item => item.id);
      const b = this.edit_data.gift_config
      const c = a.concat(b)
      const d = c.filter((item, pos) => c.indexOf(item) === pos)
      this.edit_data.gift_config = d;
    }else {
      const a = this.choose_obj.tmp_gift_list.map(item => item.id);
      const b = this.edit_data.gift_config
      const c = b.filter((item, pos) => a.indexOf(item) == -1)
      this.edit_data.gift_config = c;
    }
    
  }

  view_it(item,type){
    this.view_data = item;
    this.loading = true;
    const body = {data: item,type:type,lv:this.ranklv,page: this.pageobj2.page,count:this.pageobj2.count};
    this.httpClient.post<any>("/view_active_info.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.edit_data = res.data;
        this.rank_list = res.rank_list;
        this.pageobj2.total_count = res.total_count;
      }else{
        this.edit_data = [];      
        this.pageobj2.total_count = 0;
      }
      this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
      console.log(res, this.edit_data);
    });
  }

  ch_arr_addr(index,type){
    if(type==-1 && index>0){
      let tmp = this.edit_data.race_reward[index-1];
      this.edit_data.race_reward[index-1] = this.edit_data.race_reward[index]
      this.edit_data.race_reward[index] = tmp;
    }else if(type==1 && index < this.edit_data.race_reward.length-1){
      let tmp = this.edit_data.race_reward[index+1];
      this.edit_data.race_reward[index+1] = this.edit_data.race_reward[index]
      this.edit_data.race_reward[index] = tmp;
    }
  }

  add_reward(){
    if(this.race_obj.name.length==0){
      alert('名字不能為空');
    }else{
      const obj = {name:this.race_obj.name,num:this.race_obj.num,rank:this.race_obj.rank,lv:this.race_obj.lv,diamond:this.race_obj.diamond}

      const isDuplicate = this.edit_data.race_reward.some(item => item.rank === obj.rank && item.lv === obj.lv);
      console.log(this.edit_data.race_reward,obj);
      if (isDuplicate) {
        alert("同rank下不能有兩個同名次獎勵");
      }else{
        this.edit_data.race_reward.push(obj);
      }
    }

   
  }

  get_show_data_arr(now:number){
    if(this.edit_data.type!=now){
      this.edit_data.target_ids = [];
      this.race_obj.tmp = '1';
    }
    this.edit_data.type = now;
    this.c_r_obj[now].forEach(element => {
      if(element.id){
        this.show_data_arr[element.id] = element.name;
      }
    });
    this.aft_ck_gift();
  }


  ck_checkbox(now:number){

    const index = this.edit_data.identity_type.findIndex((v)=>{
      return now == v;
    })
    if(index==-1){
      this.edit_data.identity_type.push(now);
    }else{
      if( this.edit_data.identity_type.length==1){
        alert('至少要有一個身分');
      }else{
        this.edit_data.identity_type.splice(index,1)
      }
     
    }
    console.log(now);
  }

  choose_race_item(tmp:any){
    const index = this.edit_data.target_ids.findIndex((v)=>{
      return v == tmp.id 
    })

    if(index==-1){
      this.edit_data.target_ids.push(tmp.id);
    }else{
      this.edit_data.target_ids.splice(index,1)
    }

    for(let i in  this.edit_data.target_ids){
      if( this.edit_data.target_ids[i]== "-1" && tmp.id == "-1"){
        this.edit_data.target_ids = ["-1"];
      }else if(this.edit_data.target_ids[i]== "-1" && tmp.id != "-1"){
        const index2 = this.edit_data.target_ids.findIndex((v)=>{
          return v == "-1" 
        })
        if(index2!=-1){
          this.edit_data.target_ids.splice(index2,1)
          this.edit_data.item_config = [];
        }
      
      }
    }
  }

  /* 選不同類別要做清除 */
  target_type_adjust(type){
    this.edit_data.only_diamond = type;//0 1 2 背包物品 背包兼禮物 純鑽石
    const target_id_list = [
      ['-1'],
      ['-2'],
      []
    ];
    this.edit_data.target_ids = target_id_list[type];
    this.edit_data.gift_config = [];
    this.edit_data.item_config = [];

  }
  
  aft_ck_gift(){
    if(this.edit_data.target_ids.indexOf("10")!=-1||this.edit_data.target_ids.indexOf("-2")!=-1){
      if(this.choose_obj.now_g_tab==-1 && this.edit_data.gift_type == -1){
        this.choose_obj.now_g_tab = this.gift_list[0]['id'];
        this.choose_obj.tmp_gift_list =  this.gift_list[0]['data'];
      }else{
        this.choose_obj.now_g_tab = this.edit_data.gift_type;
        const temp =  this.gift_list.filter((item)=>item.id == this.edit_data.gift_type)
        this.choose_obj.tmp_gift_list = temp[0].data;
      
      }     
    }else if((this.edit_data.target_ids.indexOf("10")==-1||this.edit_data.target_ids.indexOf("-2")==-1) && this.choose_obj.now_g_tab!=-1){
      this.choose_obj.now_g_tab = -1;
      this.choose_obj.tmp_gift_list = [];
      this.edit_data.gift_config = [];
    }
  }



  choose(id:string){
    if(id=='1'){
      this.default_edit_data();
    }
    this.now = id;
    this.pageobj.page = 0;
  }
  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count};
    this.httpClient.post<any>("/get_active_list.php",body).subscribe(res => {
      this.loading = false;
      this.c_r_obj = res.c_and_r;
      this.gift_list = res.gift_list
      this.item_list = res.bag_item_list
      if(res.status){
        this.data = res.data;
      }else{
        this.pageobj.total_count = 0
        this.data = [];      
      }
      Rtable.structure.type = 'txt';
      let tmp_data  = {
          name:{name:'名稱'},
          sname:{name:'狀態'},
          tname:{name:'類型'},
          start_dt:{name:'開始'},
          end_dt:{name:'結束'},
          opt:{name:'操作',type:'opt'}
      }
      this.posts_attributes = Rtable.init(tmp_data);
      this.posts_input = {
        attribute:this.posts_attributes,
        content:this.data,
        sort_obj:this.sort_obj,//clone一份避免被rtable改掉
      }
      
      this.tmp_content_img_b64=undefined
      this.tmp_banner_img_b64=undefined
      this.get_show_data_arr(1);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  callback2(pageobj:page){
    if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
      this.pageobj2 = pageobj;
      this.view_it(this.view_data,0);
    }
  }

  upload(event:any,type){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        if(type==1){
          this.tmp_banner_img_b64 = e.target.result;
        }else{
          this.tmp_content_img_b64 = e.target.result;
        }
       
      });
    }
  }






  save(type){

    if(type*1 != 2 && this.edit_data.target_ids.length==0){
      alert('請選擇參賽項目');
    }else{
      let banner_img = {};
      let content_img = {};
      if(typeof(this.tmp_banner_img_b64)!='undefined'){
        banner_img = Object.keys(this.tmp_banner_img_b64).length>0 ? this.tmp_banner_img_b64:false; 
      }
      if(typeof(this.tmp_content_img_b64)!='undefined'){
        content_img = Object.keys(this.tmp_content_img_b64).length>0 ? this.tmp_content_img_b64:false; 
      }
      const body = {data:this.edit_data,banner_img:banner_img,content_img:content_img,type:type};
      this.loading = true;
      this.httpClient.post<any>("/update_active.php",body).subscribe(res => {
        console.log(res);
        this.loading = false;
        if(res.status){
          this.now = '0';
          this.init_list();
        }
      });
    }



  }

}
